const UNAVAILABLE_PLACEHOLDER = "—";

/**
 * Format click count for affiliate analytics display.
 * Abbreviates numbers >= 1000 with 'K' suffix.
 * Renders a placeholder when the value is unavailable.
 *
 * @example
 * formatAffiliateClicks(42) // "42 clicks"
 * formatAffiliateClicks(1500) // "1.5K clicks"
 * formatAffiliateClicks(10000) // "10.0K clicks"
 * formatAffiliateClicks(null) // "— clicks"
 */
export function formatAffiliateClicks(clickCount: number | null): string {
  if (clickCount === null) {
    return `${UNAVAILABLE_PLACEHOLDER} clicks`;
  }
  if (clickCount >= 1000) {
    return `${(clickCount / 1000).toFixed(1)}K clicks`;
  }
  return `${clickCount} clicks`;
}

/**
 * Format earnings amount for affiliate analytics display.
 * Abbreviates numbers >= 1000 with 'K' suffix.
 * Renders a placeholder when the value is unavailable.
 *
 * @example
 * formatAffiliateEarnings(42.50) // "$42.50"
 * formatAffiliateEarnings(1500) // "$1.5K"
 * formatAffiliateEarnings(10000) // "$10.0K"
 * formatAffiliateEarnings(null) // "—"
 */
export function formatAffiliateEarnings(amount: number | null): string {
  if (amount === null) {
    return UNAVAILABLE_PLACEHOLDER;
  }
  if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(1)}K`;
  }
  return `$${amount.toFixed(2)}`;
}
